import { render, staticRenderFns } from "./DataSpoiler.vue?vue&type=template&id=13ef2b94&scoped=true&"
import script from "./DataSpoiler.vue?vue&type=script&lang=js&"
export * from "./DataSpoiler.vue?vue&type=script&lang=js&"
import style0 from "./DataSpoiler.vue?vue&type=style&index=0&id=13ef2b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef2b94",
  null
  
)

export default component.exports